import { useEffect, useRef } from 'react';
import { useRouterState } from '@tanstack/react-router';
import { usePostHog } from 'posthog-js/react';
import { getAttributionProps } from '@/lib/attribution';
import { MARKETING_EVENTS, isMarketingPath } from '@/lib/analytics';

/**
 * Fires `marketing_page_viewed` on entry to each marketing route, carrying the
 * path, referrer, and first-touch attribution so SEO/organic landings are
 * countable as a funnel entry. Render mode is added to every event by the
 * `before_send` hook in __root.tsx. Renders nothing.
 */
export function MarketingAnalytics() {
  const posthog = usePostHog();
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const lastTracked = useRef<string | null>(null);

  useEffect(() => {
    if (!isMarketingPath(pathname) || lastTracked.current === pathname) return;
    lastTracked.current = pathname;
    posthog.capture(MARKETING_EVENTS.pageViewed, {
      path: pathname,
      referrer: document.referrer || undefined,
      ...getAttributionProps(),
    });
  }, [posthog, pathname]);

  return null;
}
